import Layout from "./layout";
import Head from "./head";
import Core from "./core";
import InputType from "./input_types";

export default {
  directives: {
    "click-outside": {
      beforeMount: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unmounted: function (el) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    },
    "seats-limit-to": {
      updated(el, binding) {
        el.addEventListener("input", eventManage.bind({ value: binding.arg }));
      },
      unmounted: function (el) {
        el.removeEventListener("input", el.__vueSeatsLimitTo__);
      }
    }
  },
  mixins: [Layout, Head, Core, InputType]
};

function eventManage(event) {
  if (+event.currentTarget.value > +this.value) {
    event.currentTarget.value = "";
  } else {
    return true;
  }
}
